<template>
  <div class="loading-container crud-standalone-listagem">
    <ErrorAlert :errors="errors"></ErrorAlert>
    <div v-if="loading" class="loading-overlay" role="status">
      <div class="loading-card">
        <span class="spinner"></span>
        <span class="label">{{ $t("Carregando") }}</span>
      </div>
    </div>
    <v-container fluid class="px-6 py-0">
      <ErrorAlert :errors="errors" />

      <v-dialog
        transition="dialog-bottom-transition"
        max-width="900"
        v-model="modalPeriodo"
        persistent
      >
        <v-card>
          <v-card-text>
            <TabelaSelecionaRecurso
              ref="tabelaPeriodo"
              @recurso="periodoSelecionado = $event"
              url="funcionarioPontoPeriodos"
              cadastro-url="cadastro.FuncionarioPontoPeriodo"
              titulo="Periodo"
              :headers="[
                {
                  text: this.$t('Inicio'),
                  value: 'inicioPeriodo',
                  sortable: 'false',
                },
                {
                  text: this.$t('Final'),
                  value: 'finalPeriodo',
                  sortable: 'false',
                },
              ]"
            />
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
              @click="closeModalPeriodo()"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              >{{ $t("Cancelar") }}</v-btn
            >
            <v-btn
              :loading="loading"
              id="btn-confirmar"
              @click="retrieveData()"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              >{{ $t("Confirmar") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="modalCadastroPeriodo"
        persistent
        max-width="900"
        transition="dialog-bottom-transition"
      >
        <CadastroFuncionarioPontoPeriodo
          v-if="modalCadastroPeriodo"
          @submitSuccessInsert="onCadastroPeriodoSuccess"
          @submitErrorInsert="onCadastroPeriodoError"
          @closeModalInsert="closeModalCadastroPeriodo"
        />
      </v-dialog>

      <v-dialog v-model="modalSelecionaArquivo" max-width="550">
        <v-card>
          <v-card-title>
            {{ $t("Importacao") }}
          </v-card-title>
          <v-col cols="12" md="12">
            <v-select
              :items="[
                { text: $t('AFD'), value: 'AFD' },
                { text: $t('AFDT'), value: 'AFDT' },
                { text: $t('AEJ'), value: 'AEJ' },
                { text: $t('CSV'), value: 'CSV' },
                { text: $t('ControlID'), value: 'ControlID' },
              ]"
              :label="$t('Tipo_importacao')"
              name="tipoImportacao"
              item-value="value"
              v-model="tipoImportacao"
              :disabled="loading"
              hide-details
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              flat
              filled
              solo
            ></v-select>
          </v-col>
          <v-col cols="12" md="12" v-if="tipoImportacao !== 'ControlID'">
            <v-card-actions>
              <input type="file" ref="doc" />
              <div>{{ statusReader }}</div>
            </v-card-actions>
          </v-col>
          <v-btn
            class="
              ma-1
              font-weight-bold
              text-none
              btn-primary
              bg-gradient-primary
              py-3
              px-6
              ms-3
            "
            height="39"
            @click="importExternal()"
            :loading="loading"
          >
            {{ $t("Confirmar") }}
          </v-btn>
          <v-btn
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            @click="modalSelecionaArquivo = false"
          >
            {{ $t("Cancelar") }}
          </v-btn>
          <v-btn
            v-if="this.tipoImportacao === 'CSV'"
            height="39"
            class="
              ma-1
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            onclick="window.location ='https://app-objetivar-img.s3.amazonaws.com/system_files/Cajupe_Modelo_Imp_Reg_Ponto.csv';"
            :loading="loading"
          >
            {{ $t("Arquivo_modelo") }}
          </v-btn>
        </v-card>
      </v-dialog>

      <v-dialog v-model="modalSelecionaExportacao" max-width="550">
        <v-card>
          <v-card-title>
            {{ $t("Selecione_tipo_exportacao") }}
          </v-card-title>
          <v-col cols="12" md="12">
            <v-select
              :items="[
                { text: $t('AFD'), value: 'AFD' },
                { text: $t('AEJ'), value: 'AEJ' },
                { text: $t('Detalhamento'), value: 'DETALHAMENTO' },
              ]"
              :label="$t('Tipo_exportacao')"
              name="tipoExportacao"
              item-value="value"
              v-model="tipoExportacao"
              :disabled="loading"
              hide-details
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              flat
              filled
              solo
            ></v-select>
          </v-col>
          <v-btn
            class="
              ma-1
              font-weight-bold
              text-none
              btn-primary
              bg-gradient-primary
              py-3
              px-6
              ms-3
            "
            height="39"
            @click="exportExternal()"
            :loading="loading"
          >
            {{ $t("Confirmar") }}
          </v-btn>
          <v-btn
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            @click="modalSelecionaExportacao = false"
          >
            {{ $t("Cancelar") }}
          </v-btn>
        </v-card>
      </v-dialog>

      <!-- Modal confirmar delete -->
      <v-dialog
        v-model="modalConfirmarDelete"
        persistent
        max-width="350"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{ $t("Tem_certeza?") }}</v-card-title>
          <v-card-text>
            <v-textarea
              v-model="justificativaInabilitacao"
              :label="$t('Justificativa')"
              maxlength="255"
              counter="255"
              outlined
              auto-grow
              rows="3"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              @click="fecharModalDelete"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              @click="deleteRecurso"
              :loading="loading"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalInsert"
        persistent
        max-width="1000px"
        :loading="loading"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5"> {{ $t("Registro") }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <BuscaSelecionaFuncionario
                    v-model="selectedFuncionario"
                    :headers="headersFuncionario"
                    :data-service="funcionarioPontoDataService"
                    item-key="funcionario.matricula"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="d-flex">
                  <CampoDataHora
                    :label="$t('Data_e_hora')"
                    @date="recurso.data = $event"
                  />
                </v-col>

                <v-col
                  cols="12"
                  class=""
                  v-if="!registroPontoTravarJustificativa"
                >
                  <div>
                    <v-text-field
                      v-model="recurso.justificativa"
                      :label="$t('Justificativa')"
                      name="Justificativa"
                      hide-details
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      flat
                      filled
                      solo
                    >
                    </v-text-field>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  class=""
                  v-if="registroPontoTravarJustificativa"
                >
                  <v-select
                    v-model="recurso.justificativa"
                    :items="splitItemsRegistroPontoJustificativa"
                    :label="$t('Justificativa')"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              @click="closeModalInsert()"
              :loading="loading"
            >
              {{ $t("Cancelar") }}
            </v-btn>
            <v-btn
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              @click="insert()"
              :loading="loading"
            >
              {{ $t("Enviar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalUpdate"
        persistent
        max-width="600px"
        :loading="loading"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5"> {{ $t("Atualizar_competencia") }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="d-flex">
                  <CampoData
                    :label="$t('Competencia')"
                    @date="recursoEdit.competencia = $event"
                  />
                </v-col>
                <v-col cols="12">
                  <span class="opacity-5 text-dark">
                    {{ $t("Status_comum") }}
                  </span>
                  <v-select
                    v-model="recursoEdit.statusComum"
                    :items="statusComumItems"
                    item-text="text"
                    item-value="value"
                    :label="$t('Status_comum')"
                    single-line
                    class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                    dense
                    flat
                    filled
                    solo
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              @click="closeModalUpdate()"
              :loading="loading"
            >
              {{ $t("Cancelar") }}
            </v-btn>
            <v-btn
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              @click="update()"
              :loading="loading"
            >
              {{ $t("Enviar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalTransferencia"
        persistent
        max-width="1050px"
        :loading="loading"
      >
        <v-card>
          <v-card-title class="d-flex align-center justify-space-between">
            <span class="text-h5">Transferir registros de ponto</span>
            <v-chip color="primary" outlined>
              {{ registrosSelecionados.length }} registro(s)
            </v-chip>
          </v-card-title>
          <v-card-text>
            <v-alert type="info" dense border="left" class="mb-4">
              Selecione o funcionário de destino vinculado à mesma pessoa do
              funcionário de origem.
            </v-alert>

            <v-row class="mb-2">
              <v-col cols="12" md="6">
                <div class="text-caption text--secondary mb-1">Origem</div>
                <div class="font-weight-bold">
                  {{
                    formatFuncionarioTransferencia(
                      funcionarioOrigemTransferencia
                    )
                  }}
                </div>
                <div class="text-caption text--secondary">
                  Pessoa ID:
                  {{
                    getPessoaIdFromFuncionario(
                      funcionarioOrigemTransferencia
                    ) || "-"
                  }}
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="text-caption text--secondary mb-1">Destino</div>
                <div class="font-weight-bold">
                  {{
                    formatFuncionarioTransferencia(
                      funcionarioDestinoTransferencia
                    )
                  }}
                </div>
                <div class="text-caption text--secondary">
                  {{ transferenciaResumoDestino }}
                </div>
              </v-col>
            </v-row>

            <BuscaSelecionaFuncionario
              :key="transferenciaBuscaKey"
              v-model="selectedFuncionarioDestinoTransferencia"
              :headers="headersFuncionario"
              :fetch-function="buscarFuncionariosDestinoTransferencia"
              item-key="funcionario.id"
              title="Funcionário de destino"
              subtitle="A busca já está limitada a funcionários da mesma pessoa."
              info-text="Não é permitido transferir para funcionário de outra pessoa."
              :auto-search="true"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              @click="closeModalTransferencia()"
              :loading="loading"
            >
              {{ $t("Cancelar") }}
            </v-btn>
            <v-btn
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              @click="confirmarTransferencia()"
              :loading="loading"
              :disabled="!transferenciaPodeConfirmar"
            >
              Confirmar transferência
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal Delete sucesso -->
      <div id="dialogDeletar">
        <v-dialog v-model="deletado" persistent max-width="350">
          <v-card>
            <v-card-title class="headline">
              {{ $t("deletado_sucesso") }}
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="
                  ma-1
                  font-weight-bold
                  text-none
                  btn-primary
                  bg-gradient-primary
                  py-3
                  px-6
                  ms-3
                "
                height="39"
                @click="deletado = false"
                :loading="loading"
              >
                {{ $t("Confirmar") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <v-card class="card-shadow border-radius-xl">
        <v-card-title>
          <v-row>
            <v-btn
              v-if="botaoCadastro"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              @click="confirmaInsert()"
              @click.stop="modalInsert = true"
              :loading="loading"
              v-can="'ROLE_FuncionarioPonto_Insert'"
              id="btn--cadastro"
            >
              <v-icon left dark> mdi-plus-circle </v-icon>
              {{ $t("Novo_registro") }}
            </v-btn>

            <v-btn
              id="periodo"
              :loading="loading"
              @click.stop="modalPeriodo = true"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
            >
              <v-icon left dark> mdi-table-sync </v-icon>
              {{ $t("Alterar_periodo") }}
            </v-btn>

            <v-btn
              :loading="loading"
              @click.stop="showimportExternal()"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              dark
              id="btn-import-payroll"
              v-can="'ROLE_FuncionarioPonto_Insert'"
            >
              <v-icon left> mdi-file-upload-outline </v-icon>
              {{ $t("Importar") }}
            </v-btn>
            <v-btn
              :loading="loading"
              @click.stop="showExportExternal()"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              dark
              id="btn-export-registers"
              v-can="'ROLE_FuncionarioPonto_List'"
            >
              <v-icon left> mdi-file-download-outline </v-icon>
              {{ $t("Exportar") }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="!registrosSelecionados.length"
              @click.stop="abrirModalTransferencia()"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              dark
              id="btn-transfer-registers"
              v-can="'ROLE_FuncionarioPonto_Update'"
            >
              <v-icon left> mdi-swap-horizontal-bold </v-icon>
              Transferir
            </v-btn>
            <v-chip
              v-if="registrosSelecionados.length"
              class="ma-1 ms-3"
              color="primary"
              outlined
            >
              {{ registrosSelecionados.length }} selecionado(s)
            </v-chip>
          </v-row>
        </v-card-title>

        <v-col cols="12">
          <template>
            <div>
              <v-row>
                <v-col cols="12">
                  <UsuarioFiltroSalvo
                    tela="FuncionarioPontos"
                    :filtro-atual="usuarioFiltroAtual"
                    :descricao-padrao="usuarioFiltroDescricaoPadrao"
                    :disabled="loading"
                    :save-disabled="!periodoSelecionado.id || loading"
                    @apply="aplicarUsuarioFiltro"
                    @error="onUsuarioFiltroError"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    hide-details
                    class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                    dense
                    flat
                    filled
                    solo
                    v-model="search.matricula"
                    :label="$t('Matricula')"
                    name="matricula"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="search.nome"
                    :label="$t('Nome')"
                    name="nome"
                    hide-details
                    class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                    dense
                    flat
                    filled
                    solo
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="filtroOrigem"
                    :items="origemItems"
                    :label="$t('Origem')"
                    item-text="text"
                    item-value="value"
                    hide-details
                    class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                    dense
                    flat
                    filled
                    solo
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="2" id="filtrar">
                  <v-btn
                    @click="filtrar()"
                    :loading="loading"
                    id="btn--filtrar"
                    :ripple="false"
                    class="
                      ma-1
                      font-weight-bold
                      text-none
                      ms-auto
                      btn-primary
                      bg-gradient-primary
                      py-3
                      px-6
                      ms-3
                    "
                    height="39"
                  >
                    <v-icon left dark> ni-zoom-split-in </v-icon>
                    {{ $t("Filtrar") }}
                  </v-btn>
                </v-col>
              </v-row>

              <v-card-text class="px-0 py-0">
                <v-data-table
                  :headers="headers"
                  :items="recursos"
                  :show-expand="true"
                  disable-pagination
                  :single-expand="true"
                  show-select
                  item-key="id"
                  v-model="registrosSelecionados"
                  :loading="loading"
                  :item-class="isStatusComum"
                  class="table"
                  :page.sync="page"
                  hide-default-footer
                  @page-count="pageCount = $event"
                  @current-items="filteredItems = $event"
                >
                  <template v-slot:[`item.data`]="{ item }">
                    {{ item.data | dataHoraParaLeituraComSegundo }}
                  </template>
                  <template v-slot:[`item.competencia`]="{ item }">
                    {{ item.competencia | dataParaLeitura }}
                  </template>
                  <template v-slot:[`item.competenciaAjustada`]="{ item }">
                    <span>{{
                      item.competenciaAjustada ? $t("sim") : $t("nao")
                    }}</span>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      v-if="editar"
                      small
                      name="editBtn"
                      icon
                      elevation="0"
                      :ripple="false"
                      v-can="'ROLE_FuncionarioPonto_Update'"
                      @click="confirmaUpdate(item)"
                      class="btn-ls me-0.90 my-1 rounded-sm ma-1"
                      color="#67748e"
                      >ni-ruler-pencil</v-icon
                    >
                    <v-icon
                      small
                      name="downloadBtn"
                      icon
                      elevation="0"
                      :ripple="false"
                      class="btn-ls me-0.90 my-1 rounded-sm ma-1"
                      color="#67748e"
                      @click="abrirComprovante(item)"
                      >mdi-download</v-icon
                    >
                    <v-icon
                      v-can="'ROLE_FuncionarioPonto_Delete'"
                      small
                      name="deleteBtn"
                      @click="confirmaDelete(item)"
                      @click.stop="modalConfirmarDelete = true"
                      :loading="loading"
                      icon
                      elevation="0"
                      :ripple="false"
                      class="btn-ls me-0.90 my-1 rounded-sm ma-1"
                      color="#67748e"
                      >ni-fat-remove</v-icon
                    >
                  </template>

                  <template v-slot:expanded-item="{ item, headers }">
                    <td :colspan="headers.length">
                      <conteudo-expansion-ponto
                        :recurso="item"
                        :loading="loading"
                      >
                      </conteudo-expansion-ponto>
                    </td>
                  </template>
                  <template v-slot:[`item.origem`]="{ item }">
                    {{ $t(item.origem) }}
                  </template>
                  <template v-slot:[`item.biometriaFacialValidacao`]="{ item }">
                    {{ $t(item.biometriaFacialValidacao || "NAOSEAPLICA") }}
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions class="card-padding">
                <v-row>
                  <v-col cols="6" lg="6" class="d-flex align-center">
                    <span class="text-body me-3"
                      >{{ $t("Itens_por_pagina") }}:</span
                    >
                    <v-col cols="3" sm="3">
                      <v-select
                        v-model="pageSize"
                        :items="pageSizes"
                        @change="handlePageSizeChange"
                        :disabled="this.isSearching"
                        hide-details
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      ></v-select>
                    </v-col>
                  </v-col>
                  <v-col cols="6" class="ml-auto d-flex justify-end">
                    <v-pagination
                      prev-icon="fa fa-angle-left"
                      next-icon="fa fa-angle-right"
                      class="pagination"
                      color="#516a78ee"
                      v-model="page"
                      :length="totalPages"
                      @input="handlePageChange"
                      :disabled="isSearching"
                      circle
                    ></v-pagination>
                  </v-col>
                </v-row>
              </v-card-actions>
            </div>
          </template>
        </v-col>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import standaloneCrudKeyboardShortcuts from "@/mixins/standaloneCrudKeyboardShortcuts";
import TabelaSelecionaRecurso from "@/components/base/proprios/TabelaSelecionaRecurso";
import BuscaSelecionaFuncionario from "@/components/base/proprios/BuscaSelecionaFuncionario";
import CadastroFuncionarioPontoPeriodo from "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo/CadastroFuncionarioPontoPeriodo.vue";
import DataService from "@/services/ComumDataService";
import FuncionarioPontoDataService from "@/services/pessoal/FuncionarioPontoDataService";
import axios from "axios";
import ConteudoExpansionPonto from "./ConteudoExpansionPonto.vue";
import UsuarioFiltroSalvo from "@/components/base/proprios/UsuarioFiltroSalvo";

export default {
  mixins: [standaloneCrudKeyboardShortcuts],
  name: "ListagemFuncionarioPontos",

  props: {
    //Props para alterações específicas ao caso
    stringCadastro: { type: String, required: false, default: "novo_cadastro" },
    opcoesLegenda: {
      type: Array,
      required: false,
      default() {
        return [
          { text: "Ativo", color: "green" },
          { text: "Inativo", color: "red" },
        ];
      },
    },
    editar: { type: Boolean, required: false, default: true },
    botaoCadastro: { type: Boolean, required: false, default: true },
  },
  components: {
    TabelaSelecionaRecurso,
    BuscaSelecionaFuncionario,
    ConteudoExpansionPonto,
    CadastroFuncionarioPontoPeriodo,
    UsuarioFiltroSalvo,
  },

  data() {
    return {
      //Recursos
      recursos: [],
      errors: [],
      modalPeriodo: true,
      modalCadastroPeriodo: false,
      modalConfirmarDelete: false,
      modalInsert: false,
      modalUpdate: false,
      modalTransferencia: false,
      loading: false,
      periodoSelecionado: {},
      periodoJaFoiBuscado: false,
      deletadoAtual: {},
      justificativaInabilitacao: "",
      deletado: false,
      todosFuncionarios: [],
      isSearching: false,
      modalSelecionaArquivo: false,
      modalSelecionaExportacao: false,
      registroImp: {},
      listRegistroImp: [],
      tipoImportacao: "",
      tipoExportacao: "AFD",
      statusReader: "",
      headers: [
        {
          text: this.$t("Matricula"),
          value: "funcionario.matricula",
          sortable: "false",
        },
        {
          text: this.$t("Funcionario"),
          value: "funcionario.nomeSocial",
          sortable: "false",
        },
        {
          text: this.$t("PostoTrabalho"),
          value: "funcionario.postoTrabalho.descricao",
          sortable: "false",
        },
        {
          text: this.$t("Escala_de_trabalho"),
          value: "funcionario.funcionarioEscalaTrabalho.descricao",
          sortable: "false",
        },
        { text: this.$t("Data"), value: "data", sortable: "false" },
        {
          text: this.$t("Competencia"),
          value: "competencia",
          sortable: "false",
        },
        {
          text: this.$t("Competencia_ajustada"),
          value: "competenciaAjustada",
          sortable: "false",
        },
        {
          text: this.$t("Origem"),
          value: "origem",
          sortable: "false",
        },
        {
          text: this.$t("Validacao_biometria_facial"),
          value: "biometriaFacialValidacao",
          sortable: "false",
        },
        {
          text: this.$t("RegistradorPontoExterno"),
          value: "registradorExterno.descricao",
          sortable: "false",
        },
        {
          text: this.$t("NSR"),
          value: "nsr",
          sortable: "false",
        },

        { text: this.$t("Acoes"), value: "actions", sortable: false },
      ],

      recurso: {
        matricula: "",
        data: "",
        justificativa: "",
      },
      selectedFuncionario: [],
      registrosSelecionados: [],
      selectedFuncionarioDestinoTransferencia: [],
      transferenciaBuscaKey: 0,
      headersFuncionario: [
        { text: this.$t("Matricula"), value: "funcionario.matricula" },
        { text: this.$t("Nome"), value: "funcionario.pessoa.nome" },
        {
          text: this.$t("Sindicato"),
          value: "funcionario.sindicato.descricao",
        },
        { text: this.$t("Cargo"), value: "funcionario.cargo.descricao" },
        {
          text: this.$t("PostoTrabalho"),
          value: "funcionario.postoTrabalho.descricao",
        },
      ],

      recursoEdit: {
        id: "",
        competencia: "",
        statusComum: "",
      },

      //Paginação
      searchApuracaoDia: "",
      search: {
        matricula: "",
        nome: "",
      },
      searchApuracao: "",

      page: 1,
      totalPages: 0,
      pageSize: 8,
      pageSizes: [8, 16, 24],
      orderBy: null,

      direction: null,
      directions: [
        { text: this.$t("Crescente"), value: "ASC" },
        { text: this.$t("Decrescente"), value: "DESC" },
      ],

      line: "",
      contentFile: null,
      filtroOrigem: null,
      origemItems: [
        { text: this.$t("Todos"), value: null },
        { text: this.$t("CAJUPE"), value: "CAJUPE" },
        { text: this.$t("CAJUPEWEB"), value: "CAJUPEWEB" },
        { text: this.$t("REGISTRADOREXTERNO"), value: "REGISTRADOREXTERNO" },
        { text: this.$t("AJUSTE"), value: "AJUSTE" },
      ],
      registroPontoTravarJustificativa: false,
      splitItemsRegistroPontoJustificativa: [],
      statusComumItems: [
        { text: "Ativo", value: "ATIVO" },
        { text: "Inativo", value: "INATIVO" },
      ],

      funcionarioPontoDataService: FuncionarioPontoDataService,
    };
  },
  mounted() {
    this.registroPontoVerificarTravaJustificativa();
  },

  watch: {
    search: function () {
      this.handleSearchChange();
    },
    modalInsert: function (val) {
      if (val) {
        this.justificativa = "";
        this.data = "";
      }
    },
    modalUpdate: function (val) {
      if (val) {
        this.competencia = "";
        this.id = "";
      }
    },
  },

  computed: {
    usuarioFiltroAtual() {
      return {
        search: {
          matricula: this.search?.matricula || "",
          nome: this.search?.nome || "",
        },
        filtroOrigem: this.filtroOrigem,
        pageSize: this.pageSize,
        orderBy: this.orderBy,
        direction: this.direction,
      };
    },

    usuarioFiltroDescricaoPadrao() {
      const partes = [];
      if (this.search?.matricula) {
        partes.push(`${this.$t("Matricula")}: ${this.search.matricula}`);
      }
      if (this.search?.nome) {
        partes.push(`${this.$t("Nome")}: ${this.search.nome}`);
      }
      if (this.filtroOrigem) {
        partes.push(`${this.$t("Origem")}: ${this.filtroOrigem}`);
      }
      return partes.filter(Boolean).join(" | ") || this.$t("Filtros");
    },

    transferenciaMesmoFuncionario() {
      if (!this.registrosSelecionados.length) {
        return false;
      }
      const ids = new Set(
        this.registrosSelecionados.map((item) =>
          this.getFuncionarioIdFromRegistro(item)
        )
      );
      return ids.size === 1 && !ids.has(null) && !ids.has(undefined);
    },

    funcionarioOrigemTransferencia() {
      if (!this.registrosSelecionados.length) {
        return null;
      }
      return this.registrosSelecionados[0]?.funcionario || null;
    },

    funcionarioDestinoTransferencia() {
      const selecionado = this.selectedFuncionarioDestinoTransferencia?.[0];
      return selecionado?.funcionario || selecionado || null;
    },

    transferenciaPodeConfirmar() {
      const origemId = this.getFuncionarioId(
        this.funcionarioOrigemTransferencia
      );
      const destinoId = this.getFuncionarioId(
        this.funcionarioDestinoTransferencia
      );
      return (
        this.transferenciaMesmoFuncionario &&
        origemId &&
        destinoId &&
        origemId !== destinoId &&
        this.getPessoaIdFromFuncionario(this.funcionarioOrigemTransferencia) ===
          this.getPessoaIdFromFuncionario(this.funcionarioDestinoTransferencia)
      );
    },

    transferenciaResumoDestino() {
      if (!this.funcionarioDestinoTransferencia) {
        return "Nenhum destino selecionado.";
      }
      return `Pessoa ID: ${
        this.getPessoaIdFromFuncionario(this.funcionarioDestinoTransferencia) ||
        "-"
      }`;
    },
  },

  methods: {
    openModalCadastroPeriodo() {
      this.modalCadastroPeriodo = true;
      this.modalPeriodo = false;
    },
    closeModalCadastroPeriodo() {
      this.modalCadastroPeriodo = false;
      this.modalPeriodo = true;
    },
    onCadastroPeriodoSuccess() {
      this.modalCadastroPeriodo = false;
      this.modalPeriodo = true;
      this.$nextTick(() => {
        this.refreshTabelaPeriodos();
      });
    },
    onCadastroPeriodoError() {
      console.log("Erro ao cadastrar periodo");
    },
    refreshTabelaPeriodos() {
      if (
        this.$refs.tabelaPeriodo &&
        typeof this.$refs.tabelaPeriodo.getRecursos === "function"
      ) {
        this.$refs.tabelaPeriodo.getRecursos();
      }
    },
    closeModalPeriodo() {
      this.modalPeriodo = false;
    },

    aplicarUsuarioFiltro(filtro) {
      if (!filtro) return;

      const search = filtro.search || {};
      this.search.matricula = search.matricula || "";
      this.search.nome = search.nome || "";
      this.filtroOrigem = filtro.filtroOrigem || null;
      this.pageSize = filtro.pageSize || this.pageSize;
      this.orderBy = filtro.orderBy || null;
      this.direction = filtro.direction || null;
      this.page = 1;

      this.$nextTick(() => {
        this.filtrar();
        if (this.modalPeriodo) {
          this.modalPeriodo = false;
        }
      });
    },

    onUsuarioFiltroError(error) {
      console.log("Erro em UsuarioFiltro", error);
    },

    retrieveData() {
      this.loading = true;
      if (!this.periodoSelecionado.id) {
        this.errors = [{ fieldName: "Periodo", message: "Campo_obrigatorio" }];
        this.loading = false;
        return;
      }

      DataService.get("funcionariosPonto/page/period", {
        params: {
          ...{ periodo: this.periodoSelecionado.id },
          ...this.getRequestParams(),
        },
      }).then((response) => {
        this.recursos = response.data.content;
        this.registrosSelecionados = [];
        this.totalPages = response.data.totalPages;
        this.pageSize = response.data.size;
        this.loading = false;
        if (this.modalPeriodo) {
          this.modalPeriodo = false;
        }
      });
    },

    filtrar() {
      if (this.hasTextFilter()) {
        this.loading = true;
        this.isSearching = true;
        DataService.get("funcionariosPonto/period/funcionario", {
          params: this.getPeriodFuncionarioRequestParams(),
        }).then((response) => {
          this.recursos = response.data;
          this.registrosSelecionados = [];
          this.loading = false;
        });
      } else {
        this.isSearching = false;
        this.retrieveData();
      }
      console.log(" this.isSearching", this.isSearching);
    },

    refreshList() {
      const hasFilter = this.hasTextFilter();

      if (this.isSearching || hasFilter) {
        this.filtrar();
        return;
      }

      this.retrieveData();
    },

    /* Paginação */
    getRequestParams() {
      let params = {};
      let page = this.page;
      let pageSize = this.pageSize;
      let orderBy = this.orderBy;
      let direction = this.direction;

      console.log("page", page);

      if (page) {
        params["page"] = page - 1;
      }

      if (pageSize) {
        params["linesPerPage"] = pageSize;
      }

      if (orderBy) {
        params["orderBy"] = orderBy;
      }

      if (direction) {
        params["direction"] = direction;
      }

      if (this.filtroOrigem) {
        params["origem"] = this.filtroOrigem;
      }

      console.log("params", params);
      return params;
    },

    hasTextFilter() {
      return Boolean(
        this.search &&
          ((this.search.matricula &&
            this.search.matricula.toString().trim().length > 0) ||
            (this.search.nome && this.search.nome.toString().trim().length > 0))
      );
    },

    getPeriodFuncionarioRequestParams() {
      const params = {
        inicio: this.periodoSelecionado.inicioPeriodo,
        final: this.periodoSelecionado.finalPeriodo,
        matricula: this.search.matricula,
        nome: this.search.nome,
      };

      if (this.filtroOrigem) {
        params.origem = this.filtroOrigem;
      }

      return params;
    },

    handleSearchChange() {
      console.log("handleSearchChange", this.search);
      if (this.search !== null && this.search.matricula > 0) {
        this.isSearching = true;
        this.getAll();
      } else {
        this.isSearching = false;
        this.retrieveData();
      }
    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveData();
    },

    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveData();
    },

    handleOrderByChange(value) {
      this.orderBy = value;
      this.page = 1;
      this.retrieveData();
    },

    handleDirectionChange(value) {
      (this.direction = value), this.retrieveData();
    },
    //Modais de confirmação
    confirmaDelete(item) {
      console.log("confirmaDelete", item);
      this.deletadoAtual = item;
      this.justificativaInabilitacao = "";
      this.modalConfirmarDelete = true;
    },

    fecharModalDelete() {
      this.modalConfirmarDelete = false;
      this.justificativaInabilitacao = "";
    },

    confirmaInsert() {
      console.log("confirmaInsert");
      this.modalInsert = true;
    },

    confirmaUpdate(item) {
      this.recursoEdit.id = item.id;
      this.recursoEdit.statusComum = item.statusComum;
      console.log("confirmaUpdate");
      console.log("id", this.recursoEdit);
      this.modalUpdate = true;
    },

    closeModalInsert() {
      this.loading = false;
      this.modalInsert = false;
    },

    closeModalUpdate() {
      this.loading = false;
      this.modalUpdate = false;
    },

    closeModalTransferencia() {
      this.loading = false;
      this.modalTransferencia = false;
      this.selectedFuncionarioDestinoTransferencia = [];
    },

    abrirModalTransferencia() {
      if (!this.registrosSelecionados.length) {
        this.$swal.fire(
          "Selecione registros",
          "Selecione ao menos um registro de ponto para transferir.",
          "warning"
        );
        return;
      }

      if (!this.transferenciaMesmoFuncionario) {
        this.$swal.fire(
          "Seleção incompatível",
          "Selecione apenas registros do mesmo funcionário para transferir.",
          "warning"
        );
        return;
      }

      if (
        !this.getPessoaIdFromFuncionario(this.funcionarioOrigemTransferencia)
      ) {
        this.$swal.fire(
          this.$t("Erro"),
          "Funcionário de origem sem pessoa vinculada.",
          "error"
        );
        return;
      }

      this.selectedFuncionarioDestinoTransferencia = [];
      this.transferenciaBuscaKey += 1;
      this.modalTransferencia = true;
    },

    async buscarFuncionariosDestinoTransferencia(params) {
      const origem = this.funcionarioOrigemTransferencia;
      const origemId = this.getFuncionarioId(origem);
      const pessoaId = this.getPessoaIdFromFuncionario(origem);

      if (!origemId || !pessoaId) {
        return [];
      }

      const response =
        await FuncionarioPontoDataService.getTransferenciaDestinos(
          origemId,
          params
        );
      const destinos = Array.isArray(response.data) ? response.data : [];

      return destinos.filter((item) => {
        const funcionario = item?.funcionario || item;
        return (
          this.getFuncionarioId(funcionario) !== origemId &&
          this.getPessoaIdFromFuncionario(funcionario) === pessoaId
        );
      });
    },

    async confirmarTransferencia() {
      if (!this.transferenciaPodeConfirmar) {
        this.$swal.fire(
          "Destino inválido",
          "Selecione um funcionário de destino vinculado à mesma pessoa.",
          "warning"
        );
        return;
      }

      const origem = this.funcionarioOrigemTransferencia;
      const destino = this.funcionarioDestinoTransferencia;
      const quantidade = this.registrosSelecionados.length;
      const confirmacao = await this.$swal.fire({
        title: "Confirmar transferência?",
        text: `${quantidade} registro(s) serão transferidos de ${this.formatFuncionarioTransferencia(
          origem
        )} para ${this.formatFuncionarioTransferencia(destino)}.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Transferir",
        cancelButtonText: this.$t("Cancelar"),
      });

      if (!confirmacao?.isConfirmed) {
        return;
      }

      this.loading = true;
      try {
        await FuncionarioPontoDataService.transferirDetalhes({
          registrosIds: this.registrosSelecionados.map((item) => item.id),
          funcionarioDestinoId: this.getFuncionarioId(destino),
        });
        this.modalTransferencia = false;
        this.selectedFuncionarioDestinoTransferencia = [];
        this.registrosSelecionados = [];
        this.loading = false;
        this.refreshList();
        this.$swal.fire(
          "Transferência realizada",
          "Registros de ponto transferidos com sucesso.",
          "success"
        );
      } catch (error) {
        this.loading = false;
        this.errors =
          error?.response?.data?.errors || error?.data?.errors || [];
        this.$swal.fire(
          this.$t("Erro"),
          this.getTransferenciaErrorMessage(error),
          "error"
        );
      }
    },

    getTransferenciaErrorMessage(error) {
      const errors = error?.response?.data?.errors || error?.data?.errors;
      if (Array.isArray(errors) && errors.length) {
        return errors
          .map((item) => item.message || item.defaultMessage || item.fieldName)
          .filter(Boolean)
          .join(" ");
      }
      return (
        error?.response?.data?.message ||
        error?.data?.message ||
        "Não foi possível transferir os registros selecionados."
      );
    },

    getFuncionarioIdFromRegistro(registro) {
      return this.getFuncionarioId(registro?.funcionario);
    },

    getFuncionarioId(funcionario) {
      return funcionario?.id || null;
    },

    getPessoaIdFromFuncionario(funcionario) {
      return funcionario?.pessoa?.id || null;
    },

    formatFuncionarioTransferencia(funcionario) {
      if (!funcionario) {
        return "Nenhum funcionário selecionado.";
      }
      const matricula = funcionario.matricula || "";
      const nome =
        funcionario.nomeSocial ||
        funcionario?.pessoa?.nome ||
        funcionario.nome ||
        "";
      if (matricula && nome) {
        return `${matricula} - ${nome}`;
      }
      return nome || matricula || "Funcionário";
    },

    registroPontoVerificarTravaJustificativa() {
      console.log("registroPontoVerificarTravaJustificativa");
      var parametrizacaoExistente =
        this.$store.state.inquilino.parametrizacoes.find(
          (item) => item.tipo == "RESTRINGIRJUSTIFICATIVAREGISTROPONTO"
        );

      if (parametrizacaoExistente) {
        this.registroPontoTravarJustificativa = parametrizacaoExistente.ativo;

        this.splitItemsRegistroPontoJustificativa =
          parametrizacaoExistente.texto
            .split(";")
            .filter((item) => item.trim() !== ""); // Separa a string pelo ';' e remove itens vazios

        console.log(
          "  this.splitItemsRegistroPontoJustificativa",
          this.splitItemsRegistroPontoJustificativa
        );
      }
    },

    insert() {
      console.log("insert", this.selectedFuncionario);
      this.loading = true;
      this.recurso.matricula =
        this.selectedFuncionario[0].funcionario?.matricula;
      DataService.post("funcionariosPonto", this.recurso).then(
        () => {
          this.loading = false;
          this.modalInsert = false;

          this.refreshList();
        },
        () => {
          this.loading = false;
          this.modalInsert = false;
          //aqui
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Verifique_periodo_de_ponto_e_funcionario"),
            "error"
          );
        }
      );
    },

    update() {
      console.log("update");
      this.loading = true;
      DataService.put(
        "funcionariosPonto/" + this.recursoEdit.id,
        this.recursoEdit
      ).then(
        () => {
          this.loading = false;
          this.modalUpdate = false;
          this.recursoEdit.competencia = "";
          this.recursoEdit.id = "";
          this.refreshList();
        },
        (error) => {
          this.loading = false;
          this.modalUpdate = false;
          this.errors = error.data.errors;
        }
      );
    },

    deleteRecurso() {
      console.log("deleteRecurso", this.deletadoAtual.id);
      FuncionarioPontoDataService.delete(
        this.deletadoAtual.id,
        this.justificativaInabilitacao.trim()
      )
        .then(() => {
          this.modalConfirmarDelete = false;
          this.justificativaInabilitacao = "";
          this.deletado = true;
          this.refreshList();
        })
        .catch((error) => {
          this.confirmar = false;
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

          this.erros = error.response.data.errors;
        });
    },

    isStatusComum: function (item) {
      return item.statusComum;
    },

    mounted() {},

    // invert(item) {
    //   FuncionarioPontoDataService.invert(item.id).then(() => {
    //     console.log("invert sucess");
    //     this.retrieveData();
    //   });
    // },

    // share(item) {
    //   FuncionarioPontoDataService.share(item.id).then(() => {
    //     console.log("share sucess");
    //     this.retrieveData();
    //   });
    // },

    editRecurso(id) {
      console.log(id);
      this.$router.push({
        name: "editar.funcionarioponto",
        params: { id: id },
      });
    },

    async abrirComprovante(item) {
      if (!item) {
        return;
      }

      const popup = this.openBlankComprovanteWindow();

      try {
        const params = this.getComprovanteParams(item);

        if (!params.inquilino || !params.data || !params.matricula) {
          throw new Error("Parametros do comprovante incompletos");
        }

        const response = await FuncionarioPontoDataService.getComprovanteLink(
          params
        );
        const link =
          typeof response.data === "string"
            ? response.data
            : response.data?.link || response.data?.url || "";

        if (!link) {
          throw new Error("Link do comprovante nao encontrado");
        }

        this.openComprovanteLink(link, popup);
      } catch (error) {
        if (popup && !popup.closed) {
          popup.close();
        }
        console.error("[FuncionarioPonto] Falha ao abrir comprovante", error);
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Falha_ao_abrir_comprovante_ponto"),
          "error"
        );
      }
    },

    getComprovanteParams(item) {
      return {
        inquilino:
          this.$store.state?.inquilino?.id ||
          this.$store.state?.user?.inquilino?.id ||
          0,
        data: this.getRegistroDataTimestamp(item),
        matricula: this.getRegistroMatricula(item),
      };
    },

    getRegistroMatricula(item) {
      return String(
        item?.funcionario?.matricula ||
          item?.matricula ||
          item?.funcionarioMatricula ||
          ""
      ).trim();
    },

    getRegistroDataTimestamp(item) {
      if (item?.date instanceof Date && !Number.isNaN(item.date.getTime())) {
        return item.date.getTime();
      }

      const raw = String(item?.data || "")
        .replace("**", "")
        .trim();

      if (!raw) {
        return 0;
      }

      if (/^\d+$/.test(raw)) {
        return Number(raw);
      }

      if (/^\d{2}\/\d{2}\/\d{4}/.test(raw)) {
        const [datePart, timePart = "00:00:00"] = raw.split(" ");
        const [dd, mm, yyyy] = datePart.split("/").map(Number);
        const [hh = 0, mi = 0, ss = 0] = timePart.split(":").map(Number);
        const parsed = new Date(yyyy, mm - 1, dd, hh, mi, ss);
        return Number.isNaN(parsed.getTime()) ? 0 : parsed.getTime();
      }

      const normalized = raw.includes("T") ? raw : raw.replace(" ", "T");
      const parsed = new Date(normalized);
      return Number.isNaN(parsed.getTime()) ? 0 : parsed.getTime();
    },

    openBlankComprovanteWindow() {
      if (typeof window === "undefined") {
        return null;
      }

      const popup = window.open("", "_blank");
      if (popup) {
        popup.opener = null;
      }
      return popup;
    },

    openComprovanteLink(link, popup = null) {
      if (popup && !popup.closed) {
        popup.location.href = link;
        return;
      }

      const opened = window.open(link, "_blank", "noopener,noreferrer");
      if (opened) {
        opened.opener = null;
      }
    },

    importExternal() {
      console.log("importExternal", this.tipoImportacao);
      if (this.tipoImportacao === "AFDT") {
        this.importAFDT();
      } else if (this.tipoImportacao === "AFD") {
        this.importAFD(this.periodoSelecionado);
      } else if (this.tipoImportacao === "AEJ") {
        this.importAEJ(this.periodoSelecionado);
      } else if (this.tipoImportacao === "CSV") {
        this.importCSV(this.periodoSelecionado);
      } else if (this.tipoImportacao === "ControlID") {
        this.importIdControl();
      } else {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Selecione_tipo_arquivo"),
          "error"
        );
      }
    },

    async importIdControl() {
      this.loading = true;
      try {
        // 1️⃣ Listar dispositivos
        const { data: dispositivos } = await axios.get(
          `registradorPontoExternos/active`
        );

        for (const disp of dispositivos) {
          // 2.1️⃣ Login no equipamento sem enviar Authorization
          const loginRes = await axios.post(
            `${disp.conexaoEndereco}/login.fcgi`,
            {
              login: disp.conexaoUsuario,
              password: disp.conexaoSenha,
            },
            {
              headers: {
                "Content-Type": "application/json",
                // zera qualquer Authorization herdado globalmente
                Authorization: undefined,
              },
            }
          );
          const session = loginRes.data.session;

          // 2.2️⃣ Exportar AFD também sem Authorization
          const { data: afdText } = await axios.post(
            `${disp.conexaoEndereco}/export_afd.fcgi?session=${session}`,
            {},
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: undefined,
              },
              responseType: "text",
            }
          );

          // 2.3️⃣ Processar e importar
          const registros = this.parseAFD(afdText, disp.serial);
          console.log("registros:", registros);
          await DataService.post("funcionariosPonto/import/rep", registros);
        }

        this.$swal.fire("Sucesso", "Importação concluída", "success");
      } catch (err) {
        console.error(err);
        this.$swal.fire("Erro", "Falha durante a importação", "error");
      } finally {
        this.loading = false;
        this.retrieveData();
        this.modalSelecionaArquivo = false;
      }
    },

    // Extrai os registros do texto AFD (mesma lógica do seu importAFDT)
    parseAFD(content, serial) {
      const list = [];

      // 1) Quebra por linha e remove vazias
      const lines = content
        .split(/\r?\n/)
        .map((l) => l.trim())
        .filter((l) => l.length > 0);

      for (const line of lines) {
        // 2) Só processa os registros de ponto (ControlID usa "3" em pos 10, índice 9)
        if (line.substr(9, 1) !== "3") continue;

        // 3) Monta o ISO-string de data/hora
        const dia = line.substr(10, 2); // pos 11–12
        const mes = line.substr(12, 2); // pos 13–14
        const ano = line.substr(14, 4); // pos 15–18
        const hora = line.substr(18, 2); // pos 19–20
        const min = line.substr(20, 2); // pos 21–22
        const data = `${ano}-${mes}-${dia}T${hora}:${min}:00`;

        // 4) PIS (pos 24–34, índice 23–33)
        const pis = line.substr(23, 11);

        // 5) Origem/terminal (pos 35–38, índice 34–37) — aqui só 4 chars
        const origem = serial;

        // 6) ControlID AFD não traz texto de justificativa completo,
        // então por enquanto deixamos sempre null
        const justificativa = null;

        list.push({ data, pis, origem, justificativa });
      }

      console.log("parseAFD", list);
      return list;
    },

    readFile() {
      return new Promise((resolve, reject) => {
        this.file = this.$refs.doc.files[0];
        const reader = new FileReader();
        if (
          this.file.name.includes(".csv") ||
          this.file.name.includes(".txt")
        ) {
          reader.onload = (res) => {
            this.modalSelecionaArquivo = false;
            resolve(res.target.result);
          };
          reader.onerror = (err) => console.log(err);
          reader.readAsText(this.file);
        } else {
          reader.onerror = reject;
          reader.onload = (res) => {
            this.modalSelecionaArquivo = false;
            resolve(res.target.result);
          };
          reader.onerror = (err) => console.log(err);
          reader.readAsText(this.file);
        }
      });
    },

    async importCSV() {
      this.loading = true;
      this.contentFile = await this.readFile();
      console.log("this.file", this.file);
      //Importação padrão CSV
      if (this.file.name.includes(".csv")) {
        //Lendo arquivo
        console.log("this.contentFile", this.contentFile);
        //Split
        const lines = this.contentFile.split("\r\n");
        lines.pop();

        //Convertendo para objeto Json
        var jsonObj = [];
        var headers = lines[0].split(";");
        for (var i = 1; i < lines.length; i++) {
          var data = lines[i].split(";");
          var obj = {};
          for (var j = 0; j < data.length; j++) {
            //Tratamentos especificos para formatações

            //Inclui no objeto apenas quando existir valor
            if (data[j].trim().length > 0) {
              //Data
              if (
                data[j].trim().indexOf("/") === 2 &&
                data[j].trim().length === 10
              ) {
                obj[headers[j].trim()] = this.formatedDate(data[j].trim());
              }
              if (
                data[j].trim().indexOf("/") === 2 &&
                data[j].trim().length === 16
              ) {
                console.log("tipo DateTime");
                obj[headers[j].trim()] = this.formatedDateTime(data[j].trim());
              } else if (headers[j].trim().indexOf("valor") !== -1) {
                obj[headers[j].trim()] = data[j]
                  .trim()
                  .replace(".", "")
                  .replace(",", ".");
              } else {
                obj[headers[j].trim()] = data[j].trim();
              }
            }
          }
          jsonObj.push(obj);
        }

        FuncionarioPontoDataService.insertSimplifiedList(jsonObj)
          .then(() => {
            this.retrieveData();
            jsonObj = [];
            this.loading = false;
            this.modalImportArquivo = false;
            this.$swal.fire(
              this.$t("Sucesso"),
              this.$t("Importacao_realizada_sucesso"),
              "success"
            );
          })
          .catch((error) => {
            //Tratando objeto de retorno
            this.loading = false;
            jsonObj = [];
            console.log("error - insertSimplifiedList", error.response.data);
            var linesErr = error.response.data.errors[0].message.split(",");
            var objTratErr = {};
            var listTratErr = [];
            var lineNumber = 0;
            for (var x = 0; x < linesErr.length; x++) {
              objTratErr = {};
              objTratErr.message = linesErr[x]
                .substring(linesErr[x].indexOf(":") + 2)
                .trim();
              lineNumber =
                parseInt(
                  linesErr[x].substring(
                    linesErr[x].indexOf("[") + 1,
                    linesErr[x].indexOf("]")
                  )
                ) + 2;
              objTratErr.fieldName =
                "Linha: " +
                lineNumber.toString() +
                " - " +
                linesErr[x].substring(
                  linesErr[x].indexOf("]") + 2,
                  linesErr[x].indexOf(":")
                );
              objTratErr.line = lineNumber;
              listTratErr.push(objTratErr);
              //console.log("objTratErr", objTratErr);
            }
            listTratErr = listTratErr.sort(this.compareArrayError);
            this.modalImportArquivo = false;
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            //console.log("error.response", error.response);
            this.errors = listTratErr;
          });
      } else {
        this.loading = false;
        this.modalImportArquivo = false;

        this.$swal.fire(this.$t("Erro"), this.$t("Arquivo_invalido"), "error");
      }
    },

    formatedDateTime: function (dataValue) {
      let data = dataValue;
      console.log("data - formatedDateTime", data);
      console.log("data - formatedDateTime - length", data.length);
      if (data.length == 16) {
        console.log(data.toString());
        var dia = data.split("/")[0];
        var mes = data.split("/")[1];
        var ano = data.split("/")[2].split(" ")[0];

        var horamin = data.split(" ")[1];
        var horas = horamin.split(":")[0];
        var minutos = horamin.split(":")[1];

        let string =
          ano + "-" + mes + "-" + dia + "T" + horas + ":" + minutos + ":00";
        console.log("formated", string);
        return string;
      } else {
        return data;
      }
    },
    async importAFDT() {
      this.loading = true;

      console.log("ImportAFDT");

      this.contentFile = await this.readFile(this.file);
      this.loading = true;

      var lines = this.contentFile.split("\n");
      this.listRegistroImp = [];
      for (var line = 0; line < lines.length; line++) {
        this.line = lines[line];
        //console.log("Tipo linha", this.line.substr(0, 1));
        //console.log("linha", this.line);
        //Importação DEXION
        if (
          this.line.substr(9, 1) === "2" &&
          (this.line.substr(51, 1) === "E" || this.line.substr(51, 1) === "S")
        ) {
          //Limpando dados
          this.registroImp = {
            data: "",
            justificativa: "",
            origem: "",
            pis: "",
          };

          this.registroImp.pis = this.line.substr(23, 11);
          this.registroImp.data =
            this.line.substr(14, 4) +
            "-" +
            this.line.substr(12, 2) +
            "-" +
            this.line.substr(10, 2) +
            "T" +
            this.line.substr(18, 2) +
            ":" +
            this.line.substr(20, 2) +
            ":00";
          this.registroImp.origem = this.line.substr(34, 17);
          if (this.line.substr(54, 1) === "I") {
            this.registroImp.justificativa = this.line.substr(55, 100).trim();
          } else {
            this.registroImp.justificativa = null;
          }

          this.listRegistroImp.push(this.registroImp);
        }
      }

      console.log("Registros Imp: ");
      console.log(this.listRegistroImp);
      await DataService.post(
        "funcionariosPonto/import/rep",
        this.listRegistroImp
      )
        .then(() => {
          console.log("DataService.post(funcionariosPonto/import/rep");
        })
        .catch(() => {
          // this.loading = false;
          // jsonObj = [];
          // console.log("error - insertSimplifiedList", error.response);
          // this.$swal.fire(
          //   this.$t("Erro"),
          //   this.$t("Favor_tente_novamente_mais_tarde"),
          //   "error"
          // );
        });

      this.modalSelecionaArquivo = false;
      this.loading = false;
      this.$swal.fire(
        this.$t("Sucesso"),
        this.$t("Importacao_realizada"),
        "success"
      );
    },

    async importAFD(periodo, contentFile) {
      console.log("importAFD");
      const inicioPeriodo = new Date(periodo.inicioPeriodo);
      const finalPeriodo = new Date(periodo.finalPeriodo);

      // 1) Carrega linhas
      let lines;
      if (contentFile) {
        lines = contentFile.split(/\r\n|\r|\n/).filter((l) => l.trim());
      } else {
        this.contentFile = await this.readFile(this.file);
        lines = this.contentFile.split(/\r\n|\r|\n/).filter((l) => l.trim());
        this.loading = true;
      }

      // Helpers
      const pad2 = (n) => String(n).padStart(2, "0");
      const onlyDigits = (s) => (s || "").replace(/\D/g, "");
      const normTz = (s) => s.replace(/([+-]\d{2})(\d{2})$/, "$1:$2"); // -0300 -> -03:00 (para Date)
      const toLocalDateTime = (d) =>
        `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(
          d.getDate()
        )}T${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(
          d.getSeconds()
        )}`;

      // Header: origem (671 = pos. 190–206; senão, último bloco de 17 dígitos)
      const extractOrigemFromHeader = (line) => {
        const ver = (line.substr(250, 3) || "").trim(); // 671 indica "003" aqui
        if (ver === "003") {
          return (line.substr(189, 17) || "").trim(); // 0-based
        }
        const m = line.match(/\d{17}(?!\d)/g);
        return m && m.length ? m[m.length - 1] : "";
      };

      // PIS clássico (1510): pos. 23–34 → 12 chars → manter últimos 11 dígitos
      const extractPis1510 = (line) => {
        const raw = line.length >= 34 ? line.substr(22, 12) : ""; // 0-based
        let d = onlyDigits(raw);
        if (d.length < 11) d = d.padStart(11, "0");
        return d.slice(-11) || null;
      };

      // CPF 671: pos. 35–46 → 12 chars → manter últimos 11 dígitos (sem validar)
      const extractCpf671 = (line) => {
        const raw = line.length >= 46 ? line.substr(34, 12) : "";
        let d = onlyDigits(raw);
        if (d.length < 11) d = d.padStart(11, "0");
        return d.slice(-11) || null;
      };

      this.listRegistroImp = [];
      let origem = "";

      // Envio em lotes
      const enviaLote = async () => {
        if (!this.listRegistroImp.length) return;
        try {
          await DataService.post(
            "funcionariosPonto/import/rep",
            this.listRegistroImp
          );
        } catch (e) {
          console.error("Erro no envio:", e);
        }
        this.listRegistroImp = [];
      };

      // 2) Processa
      for (const line of lines) {
        if (!line || line.length < 10) continue;
        const tipo = line[9];

        // Cabeçalho (tipo 1)
        if (tipo === "1") {
          origem = extractOrigemFromHeader(line) || origem;
          continue;
        }

        // Marcações: tipo 3 (REP-A/C e 1510) e tipo 7 (REP-P)
        if (tipo === "3" || tipo === "7") {
          const reg = {
            nsr: line.substr(0, 9).trim(),
            origem,
            data: "", // SEM offset (LocalDateTime)
            pis: null,
            cpf: null,
            justificativa: "",
          };

          // Tenta layout 671: DH ISO com offset nas pos. 11–34 (24 chars)
          const dhISO = line.substr(10, 24);
          const is671 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{4}$/.test(
            dhISO
          );

          if (is671 && (tipo === "3" || tipo === "7")) {
            // --- Portaria 671 (REP-A/C/P) ---
            const dt = new Date(normTz(dhISO));
            reg.data = toLocalDateTime(dt);

            // CPF: pos. 35–46 (12) -> manter 11 últimos dígitos
            reg.cpf = extractCpf671(line);
            reg.justificativa = `NSR:${reg.nsr}`;
          } else if (tipo === "3") {
            // --- Portaria 1510 (antigo) ---
            // Data em ddmmaaaa (pos. 11–18), hora hhmm (pos. 19–22)
            if (line.length >= 22) {
              const dd = line.substr(10, 2);
              const mm = line.substr(12, 2);
              const aaaa = line.substr(14, 4);
              const hh = line.substr(18, 2);
              const min = line.substr(20, 2);
              reg.data = `${aaaa}-${mm}-${dd}T${hh}:${min}:00`;
            }

            // PIS: pos. 23–34 (12) -> manter 11 últimos dígitos
            reg.pis = extractPis1510(line);
            reg.justificativa = `NSR:${reg.nsr}`;
          } else {
            // segurança: se for tipo 7 sem ISO (não deveria ocorrer), ignora
            continue;
          }

          // Filtro por período (string sem offset => interpretada como local)
          const dtCheck = new Date(reg.data);
          if (
            !isNaN(dtCheck.getTime()) &&
            dtCheck >= inicioPeriodo &&
            dtCheck <= finalPeriodo
          ) {
            this.listRegistroImp.push(reg);
          }
        }

        // Trailer: envia lote
        if (line.startsWith("999999999")) {
          await enviaLote();
        }
      }

      // Envia restante
      await enviaLote();

      // UI
      this.loading = false;
      this.modalSelecionaArquivo = false;
      this.$swal.fire(
        this.$t("Sucesso"),
        this.$t("Importacao_realizada"),
        "success"
      );
    },

    async importAEJ(periodo, contentFile) {
      console.log("importAEJ");
      const inicioPeriodo = periodo?.inicioPeriodo
        ? new Date(periodo.inicioPeriodo)
        : null;
      const finalPeriodo = periodo?.finalPeriodo
        ? new Date(periodo.finalPeriodo)
        : null;
      const hasPeriodoValido =
        inicioPeriodo instanceof Date &&
        !isNaN(inicioPeriodo.getTime()) &&
        finalPeriodo instanceof Date &&
        !isNaN(finalPeriodo.getTime());

      this.loading = true;

      let lines;
      if (contentFile) {
        lines = contentFile.split(/\r\n|\r|\n/).filter((l) => l.trim());
      } else {
        this.contentFile = await this.readFile(this.file);
        lines = this.contentFile.split(/\r\n|\r|\n/).filter((l) => l.trim());
      }

      const pad2 = (n) => String(n).padStart(2, "0");
      const onlyDigits = (s) => (s || "").replace(/\D/g, "");
      const normalizeCpf = (raw) => {
        let d = onlyDigits(raw);
        if (!d) return null;
        if (d.length < 11) d = d.padStart(11, "0");
        return d.slice(-11);
      };
      const normalizeRep = (raw) => {
        let d = onlyDigits(raw);
        if (!d) return "";
        if (d.length < 17) d = d.padStart(17, "0");
        return d.slice(-17);
      };
      const toLocalDateTime = (d) =>
        `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(
          d.getDate()
        )}T${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(
          d.getSeconds()
        )}`;
      const parseDateTimeAej = (value) => {
        const raw = (value || "").trim();
        if (!raw) return null;
        const withOffset = raw.replace(/([+-]\d{2}):?(\d{2})$/, "$1:$2");
        const d = new Date(withOffset);
        if (isNaN(d.getTime())) return null;
        return toLocalDateTime(d);
      };

      const repById = {};
      const cpfByVinculo = {};

      // 1) Mapear vínculo (registro 03) e origem/REP (registro 02)
      for (const rawLine of lines) {
        const line = rawLine.trim();
        if (!line) continue;

        const cols = line.split("|");
        const tipo = (cols[0] || "").trim();

        if (tipo === "02") {
          const idRepAej = (cols[1] || "").trim();
          const nrRep = normalizeRep(cols[3]);
          if (idRepAej) {
            repById[idRepAej] = nrRep;
          }
        } else if (tipo === "03") {
          const idtVinculoAej = (cols[1] || "").trim();
          const cpf = normalizeCpf(cols[2]);
          if (idtVinculoAej && cpf) {
            cpfByVinculo[idtVinculoAej] = cpf;
          }
        }
      }

      this.listRegistroImp = [];
      const enviaLote = async () => {
        if (!this.listRegistroImp.length) return;
        try {
          await DataService.post(
            "funcionariosPonto/import/rep",
            this.listRegistroImp
          );
        } catch (e) {
          console.error("Erro no envio:", e);
        }
        this.listRegistroImp = [];
      };

      // 2) Importar marcações (registro 05)
      for (const rawLine of lines) {
        const line = rawLine.trim();
        if (!line) continue;

        const cols = line.split("|");
        const tipo = (cols[0] || "").trim();
        if (tipo !== "05") continue;

        const idtVinculoAej = (cols[1] || "").trim();
        const data = parseDateTimeAej(cols[2]);
        const idRepAej = (cols[3] || "").trim();
        const tpMarc = (cols[4] || "").trim().toUpperCase();
        const seqEntSaida = (cols[5] || "").trim();
        const fonteMarc = (cols[6] || "").trim().toUpperCase();
        const motivo = (cols[8] || "").trim();

        // Importa apenas marcações efetivas de entrada/saída
        if (!data || (tpMarc !== "E" && tpMarc !== "S")) continue;

        const reg = {
          origem: repById[idRepAej] || "",
          data,
          pis: null,
          cpf: cpfByVinculo[idtVinculoAej] || null,
          justificativa:
            motivo || `AEJ:${fonteMarc || "O"}${tpMarc}${seqEntSaida || ""}`,
        };

        if (!reg.cpf) continue;

        const dtCheck = new Date(reg.data);
        if (
          !hasPeriodoValido ||
          (!isNaN(dtCheck.getTime()) &&
            dtCheck >= inicioPeriodo &&
            dtCheck <= finalPeriodo)
        ) {
          this.listRegistroImp.push(reg);
        }

        if (this.listRegistroImp.length >= 1000) {
          await enviaLote();
        }
      }

      await enviaLote();

      this.loading = false;
      this.modalSelecionaArquivo = false;
      this.$swal.fire(
        this.$t("Sucesso"),
        this.$t("Importacao_realizada"),
        "success"
      );
    },

    showimportExternal() {
      this.modalSelecionaArquivo = true;
    },

    showExportExternal() {
      this.tipoExportacao = "AFD";
      this.modalSelecionaExportacao = true;
    },

    exportExternal() {
      if (this.tipoExportacao === "AEJ") {
        this.exportarAej();
      } else if (this.tipoExportacao === "AFD") {
        this.exportarAfd();
      } else if (this.tipoExportacao === "DETALHAMENTO") {
        this.exportarDetalhamento();
      } else {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Selecione_tipo_exportacao"),
          "error"
        );
      }
    },

    exportarAfd() {
      this.loading = true;
      DataService.put("funcionariosPonto/exportarAfd", this.periodoSelecionado)
        .then((res) => {
          console.log("res", res, res.data);
          this.loading = false;
          this.modalSelecionaExportacao = false;
          this.download(
            res.data,
            "AFD_" +
              this.periodoSelecionado.inicioPeriodo +
              "_" +
              this.periodoSelecionado.finalPeriodo +
              ".txt",
            "application/txt"
          );

          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Documento_gerado_com_sucesso"),
            "success"
          );
        })
        .catch((error) => {
          this.loading = false;
          this.modalSelecionaExportacao = false;
          this.erros = error.response.data.errors;
        });
    },

    getExportarDetalhamentoParams() {
      return {
        periodo: this.periodoSelecionado.id,
        inicio: this.periodoSelecionado.inicioPeriodo,
        fim: this.periodoSelecionado.finalPeriodo,
        matricula: this.search.matricula,
        nome: this.search.nome,
        origem: this.filtroOrigem,
      };
    },

    exportarDetalhamento() {
      if (!this.periodoSelecionado.id) {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Periodo_obrigatorio"),
          "error"
        );
        return;
      }

      this.loading = true;
      DataService.put(
        "funcionariosPonto/exportarDetalhamento",
        this.getExportarDetalhamentoParams(),
        {
          responseType: "arraybuffer",
        }
      )
        .then((res) => {
          this.loading = false;
          this.modalSelecionaExportacao = false;
          this.download(
            res.data,
            "Detalhamento_" +
              this.periodoSelecionado.inicioPeriodo +
              "_" +
              this.periodoSelecionado.finalPeriodo +
              ".pdf",
            "application/pdf"
          );

          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Documento_gerado_com_sucesso"),
            "success"
          );
        })
        .catch((error) => {
          this.loading = false;
          this.modalSelecionaExportacao = false;
          this.errors = error?.response?.data?.errors || [];
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Tente_novamente_mais_tarde"),
            "error"
          );
        });
    },

    exportarAej() {
      this.loading = true;
      DataService.put(
        "funcionariosPonto/exportarAej",
        this.periodoSelecionado,
        {
          responseType: "arraybuffer",
        }
      )
        .then((res) => {
          this.loading = false;
          this.modalSelecionaExportacao = false;
          this.download(
            res.data,
            "AEJ_" +
              this.periodoSelecionado.inicioPeriodo +
              "_" +
              this.periodoSelecionado.finalPeriodo +
              ".zip",
            "application/zip"
          );

          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Documento_gerado_com_sucesso"),
            "success"
          );
        })
        .catch((error) => {
          this.loading = false;
          this.modalSelecionaExportacao = false;
          this.erros = error?.response?.data?.errors || [];
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Tente_novamente_mais_tarde"),
            "error"
          );
        });
    },

    download(content, fileName, mimeType) {
      var a = document.createElement("a");
      mimeType = mimeType || "application/octet-stream";

      if (navigator.msSaveBlob) {
        // IE10
        navigator.msSaveBlob(
          new Blob([content], {
            type: mimeType,
          }),
          fileName
        );
      } else if (URL && "download" in a) {
        //html5 A[download]
        a.href = URL.createObjectURL(
          new Blob([content], {
            type: mimeType,
          })
        );
        a.setAttribute("download", fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        location.href =
          "data:application/octet-stream," + encodeURIComponent(content); // only this mime type is supported
      }
    },
    utils_todayPlusDays(days) {
      let now = new Date();
      now.setDate(now.getDate() + days);
      return now;
    },
  },

  beforeInsert() {
    if (
      this.selectedFuncionario.length > 0 &&
      this.selectedFuncionario[0].funcionario
    ) {
      this.recurso.matricula =
        this.selectedFuncionario[0].funcionario.matricula;
      this.recurso.funcionario = { ...this.selectedFuncionario[0].funcionario };
    } else {
      this.recurso.matricula = "";
      this.recurso.funcionario = null;
    }
    return this.recurso.matricula;
  },
};
</script>

<style>
.doubt-btn {
  position: fixed;
  right: 10px;
  bottom: 10px;
}

#app .INATIVO {
  color: red;
}

#app .ATIVO {
  color: #67748e;
}

.rounded-div {
  background-color: red;
  border-radius: 999px;
}
</style>
